/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FetchConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchConfigQuery = { __typename?: 'Query', fetchConfig: any };

export type SaveConfigMutationVariables = Types.Exact<{
  config: Types.ConfigInput;
}>;


export type SaveConfigMutation = { __typename?: 'Mutation', saveConfig: any };


export const FetchConfigDocument = gql`
    query FetchConfig {
  fetchConfig
}
    `;

export function useFetchConfigQuery(options?: Omit<Urql.UseQueryArgs<FetchConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchConfigQuery>({ query: FetchConfigDocument, ...options });
};
export const SaveConfigDocument = gql`
    mutation SaveConfig($config: ConfigInput!) {
  saveConfig(config: $config)
}
    `;

export function useSaveConfigMutation() {
  return Urql.useMutation<SaveConfigMutation, SaveConfigMutationVariables>(SaveConfigDocument);
};